/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
	let search = params;
	search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
	dateRange = Array.isArray(dateRange) ? dateRange : [];
	if (typeof (propName) === 'undefined') {
		search.params['beginTime'] = dateRange[0];
		search.params['endTime'] = dateRange[1];
	} else {
		search.params['begin' + propName] = dateRange[0];
		search.params['end' + propName] = dateRange[1];
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].value == ('' + value)) {
			actions.push(datas[key].label);
			return true;
		}
	})
	return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
	var actions = [];
	var currentSeparator = undefined === separator ? "," : separator;
	var temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
		Object.keys(datas).some((key) => {
			if (datas[key].value == ('' + temp[val])) {
				actions.push(datas[key].label + currentSeparator);
			}
		})
	})
	return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

// 数据合并
export function mergeRecursive(source, target) {
	for (var p in target) {
		try {
			if (target[p].constructor == Object) {
				source[p] = mergeRecursive(source[p], target[p]);
			} else {
				source[p] = target[p];
			}
		} catch (e) {
			source[p] = target[p];
		}
	}
	return source;
};

 /**大小写转换 */
export function  toLowerCaseJson(obj) {
	if (!obj) {
	  return obj;
	}
	var str =  JSON.stringify(obj)
	let res = str.replaceAll("NODEDATA","nodedata").replaceAll("TEXT","text");
	return JSON.parse(res);
  };

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
	let config = {
		id: id || 'id',
		parentId: parentId || 'parentId',
		childrenList: children || 'children'
	};

	var childrenListMap = {};
	var nodeIds = {};
	var tree = [];

	for (let d of data) {
		let parentId = d[config.parentId];
		if (childrenListMap[parentId] == null) {
			childrenListMap[parentId] = [];
		}
		nodeIds[d[config.id]] = d;
		childrenListMap[parentId].push(d);
	}

	for (let d of data) {
		let parentId = d[config.parentId];
		if (nodeIds[parentId] == null) {
			tree.push(d);
		}
	}

	for (let t of tree) {
		adaptToChildrenList(t);
	}

	function adaptToChildrenList(o) {
		if (childrenListMap[o[config.id]] !== null) {
			o[config.childrenList] = childrenListMap[o[config.id]];
		}
		if (o[config.childrenList]) {
			for (let c of o[config.childrenList]) {
				adaptToChildrenList(c);
			}
		}
	}
	return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		var part = encodeURIComponent(propName) + "=";
		if (value !== null && typeof (value) !== "undefined") {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && typeof (value[key]) !== 'undefined') {
						let params = propName + '[' + key + ']';
						var subPart = encodeURIComponent(params) + "=";
						result += subPart + encodeURIComponent(value[key]) + "&";
					}
				}
			} else {
				result += part + encodeURIComponent(value) + "&";
			}
		}
	}
	return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
	try {
		const text = await data.text();
		JSON.parse(text);
		return false;
	} catch (error) {
		return true;
	}
}

export function getUrlKey(name) {
	return decodeURIComponent(
		(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

/**
    
* 判断是否为空
    
*/

export function validatenull(val) {

	if (typeof val == 'boolean') {

		return false;

	}

	if (typeof val == 'number') {

		return false;

	}

	if (val instanceof Array) {

		if (val.length == 0) return true;

	} else if (val instanceof Object) {

		if (JSON.stringify(val) === '{}') return true;

	} else {

		if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;

		return false;

	}

	return false;

}


/**
    
* 判断身份证号码
    
*/

export function cardid(code) {

	let list = [];

	let result = true;

	let msg = '';

	var city = {

		11: "北京",

		12: "天津",

		13: "河北",

		14: "山西",

		15: "内蒙古",

		21: "辽宁",

		22: "吉林",

		23: "黑龙江 ",

		31: "上海",

		32: "江苏",

		33: "浙江",

		34: "安徽",

		35: "福建",

		36: "江西",

		37: "山东",

		41: "河南",

		42: "湖北 ",

		43: "湖南",

		44: "广东",

		45: "广西",

		46: "海南",

		50: "重庆",

		51: "四川",

		52: "贵州",

		53: "云南",

		54: "西藏 ",

		61: "陕西",

		62: "甘肃",

		63: "青海",

		64: "宁夏",

		65: "新疆",

		71: "台湾",

		81: "香港",

		82: "澳门",

		91: "国外 "

	};

	if (!validatenull(code)) {

		if (code.length == 18) {

			if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {

				msg = "证件号码格式错误";

			} else if (!city[code.substr(0, 2)]) {

				msg = "地址编码错误";

			} else {

				//18位身份证需要验证最后一位校验位

				code = code.split('');

				//∑(ai×Wi)(mod 11)

				//加权因子

				var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

				//校验位

				var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x'];

				var sum = 0;

				var ai = 0;

				var wi = 0;

				for (var i = 0; i < 17; i++) {

					ai = code[i];

					wi = factor[i];

					sum += ai * wi;

				}

				if (parity[sum % 11] != code[17]) {

					msg = "证件号码校验位错误";

				} else {

					result = false;

				}



			}

		} else {

			msg = "证件号码长度不为18位";

		}



	} else {

		msg = "证件号码不能为空";

	}

	list.push(result);

	list.push(msg);

	return list;

}

/**
    
* 判断手机号码是否正确
    
*/

export function isvalidatemobile(phone) {

	let list = [];

	let result = true;

	let msg = '';

	var isPhone = /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/;

	//增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]

	if (!validatenull(phone)) {

		if (phone.length == 11) {

			if (!isPhone.test(phone)) {

				msg = '手机号码格式不正确';

			} else {

				result = false;

			}

		} else {

			msg = '手机号码长度不为11位';

		}

	} else {

		msg = '手机号码不能为空';

	}

	list.push(result);

	list.push(msg);

	return list;

}




// WEBPACK FOOTER //
// ./src/utils/ruoyi.js